import { EContentType } from '@/interfaces/doccen-lib/contentManagement.interface';
import { SearchFeedContext } from '@/pages/home/search';
import {
  IMultiLevelDropdown,
  IMultiLevelDropdownDataItem,
} from 'design-system/components/MultiLevelDropdown';
import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

//this to prevent changing too many old files
export { EContentType } from '@/interfaces/doccen-lib/contentManagement.interface';

export const hashContentTypeLabel = {
  [EContentType.All]: 'Tất cả',
  [EContentType.Document]: 'Tài liệu',
  [EContentType.Collection]: 'Bộ sưu tập',
  [EContentType.Course]: 'Khóa học',
};

export interface ILibraryFilterContext {
  categories: IMultiLevelDropdown['value'];
  setCategories: Dispatch<SetStateAction<IMultiLevelDropdown['value']>>;
  contentType: EContentType;
  setContentType: Dispatch<SetStateAction<EContentType>>;
  categoriesArray: Omit<IMultiLevelDropdownDataItem, 'categories'>[];
}

export const LibraryFilterContext = createContext<ILibraryFilterContext>({
  categories: {},
  setCategories: () => {},
  contentType: EContentType.All,
  setContentType: () => {},
  categoriesArray: [],
});

const LibraryFilterProvider = ({
  children,
  contentType: contentTypeFromQuery,
}: PropsWithChildren<{
  contentType?: string;
}>) => {
  const [categories, setCategories] = useState<IMultiLevelDropdown['value']>(
    {}
  );
  const { currentTab } = useContext(SearchFeedContext);

  const [contentType, setContentType] = useState<EContentType>(
    Object.values(EContentType).includes(contentTypeFromQuery as EContentType)
      ? (contentTypeFromQuery as EContentType)
      : EContentType.All
  );

  const categoriesArray = useMemo(() => {
    return Object.values(categories);
  }, [categories]);

  return (
    <LibraryFilterContext.Provider
      value={{
        categories,
        setCategories,
        contentType: currentTab === 0 ? EContentType.All : contentType,
        setContentType,
        categoriesArray,
      }}
    >
      {children}
    </LibraryFilterContext.Provider>
  );
};

export default LibraryFilterProvider;
